import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { AvnetUsaV3CredentialsInputDTORuntype, AvnetUsaV3ResponseBodyDTORuntype } from './avnetUsaV3BackendTypes';

export const avnetUsaV3Endpoints = {
    'GET /3rdparty/avnetusav3/credentials': endpoint({
        description: 'Returns credentials for Avnet USA integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: AvnetUsaV3ResponseBodyDTORuntype,
    }),
    'POST /3rdparty/avnetusav3/credentials': endpoint({
        description: 'Uploads credentials for Avnet USA V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AvnetUsaV3CredentialsInputDTORuntype,
        responseBody: AvnetUsaV3ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/avnetusav3/credentials'],
    }),
    'PATCH /3rdparty/avnetusav3/credentials': endpoint({
        description: 'Updates credentials for Avnet USA V3 API integratoin',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AvnetUsaV3CredentialsInputDTORuntype,
        responseBody: AvnetUsaV3ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/avnetusav3/credentials'],
    }),
    'DELETE /3rdparty/avnetusav3/credentials': endpoint({
        description: 'Deletes existing credentials for Avnet USA V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/avnetusav3/credentials'],
    }),
};
